import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Alert, Spinner } from 'react-bootstrap';
import esptrans from '../../../assets/esp-trans.png';
import styles from '../../../styles.module.css';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import useTrans from '../../../hooks/useTrans';

export default function EspelhoTrans() {
  const { id } = useParams();
  const { data: trans, error, isLoading } = useTrans(id);
  const laudoTrans = trans?.[0];

  return (
    <Card style={{ marginTop: 10, marginBottom: 10 }}>
      <LaudoCardHeader title="ECOCARDIOGRAMA TRANSESOFÁGICO" />

      {error && !isLoading && (
        <Alert variant="danger" style={{ marginTop: 10 }}>
          <Alert.Heading>Erro ao carregar laudo de trans!</Alert.Heading>
          <p>Tente novamente.</p>
        </Alert>
      )}

      {isLoading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <Spinner animation="border" variant="dark" size="lg" />
        </div>
      )}

      {!isLoading && !error && laudoTrans && (
        <>
          <Card.Body>
            <strong className="mr-auto">Cod Trans: </strong>
            {laudoTrans.CODTRANS}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${laudoTrans.CODPAC} - ${laudoTrans.NOMEPAC}`}
            <br></br>
            <strong className="mr-auto">Data de Nasc: </strong>
            {`${laudoTrans.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {`${laudoTrans.SEXOPAC}`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${laudoTrans.idadePAC} anos`} 
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Alt: ______</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Peso: ______</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">SC: ______</strong>
            <br></br>
            <strong className="mr-auto">Convênio: </strong>
            {laudoTrans.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {laudoTrans.dataTrans}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Fone: </strong>
            {laudoTrans.CELULARPAC}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br></br>
            <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
            {`${laudoTrans.Solicitou}`}
            <hr></hr>
            <div className={styles.imageReport}>
              <img
                width="90%"
                height="130%"
                loading="lazy"
                src={esptrans}
                alt="espelho trans"
              />{' '}
            </div>
          </Card.Body>
          <Card.Footer id="removeMe" className="text-center">
            <Button variant="outline-primary" onClick={() => window.print()}>
              Imprimir
            </Button>
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
